/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Obsługa schowka
 *
 * @export
 * @class Clipboard
 */

export class Clipboard {
	constructor() {
		this.isActualSimpleClipboardContent = false;
		this.isSimpleClipboardContentTimer = null;
	}
	// ****************************************************************************************************
	// Inicjalizacja schowka
	// ****************************************************************************************************
	init() {
	}
	// ****************************************************************************************************
	// Ładowanie uproszczonego schowka do popover
	// ****************************************************************************************************
	loadSimpleClipboardContent() {
		var that = this;
		var target = $('#clipboardSimpleContent, #' + $('#clipboardBtn').attr('aria-describedby') + ' .popover-body');
		;
		if (!that.isActualSimpleClipboardContent) {
			that.isActualSimpleClipboardContent = true;
			$.ajax({
				url: '/clipboard?content=simple&current_action=ajax',
				beforeSend: function () {
					target.html('<img class="d-block mx-auto align-self-center mw-100" src="/img/loading.gif" id="loadingGIF" />');
				},
				success: function (data) {
					target.html(data);
					that.loadSimpleClipboardContentTimer();
				}
			});
		}
		else {
			that.loadSimpleClipboardContentTimer();
		}
	}
	loadSimpleClipboardContentTimer() {
		var that = this;
		clearTimeout(that.isSimpleClipboardContentTimer);
		that.isSimpleClipboardContentTimer = setTimeout(function () {
			that.isActualSimpleClipboardContent = false;
		}, SIMPLE_CONTENT_LIFE_TIME);
	}
}